import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import {  FormGroup, Label, Input, } from "reactstrap";
import Loading from "../components/Loading.js";
import FindePage from "./FindePage.js";
import Footer from "../components/Footer.js";
import RechercheParVille from "./RechercheParVille.js";
import CardNotaire from "./CardNotaire.js";
import CtaNotaire from "./CtaNotaire.js";
import axios from "axios";
import { Navbar } from '../Navbar.js';
import {  FormS, Pagination,  } from "../style/Annuaire.js";
import { ChevronRightIcon } from '@heroicons/react/20/solid'
import ArticlesSidebar from "./ArticlesSidebar.js";

function NotairesVilleParis(args) {
  const [notaires, setNotaires] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [state, setState] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const [data, setData] = useState([]);
  const [dataNotaires, setDataNotaires] = useState([]);
  const [itemsPage, setItemsPage] = useState([]);

  const { nameCity } = useParams();

  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 30;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const totalPages = Math.ceil(notaires?.length / itemsPerPage);

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Cette option permet d'avoir un défilement fluide
    });
  };

  const SPREADSHEET_ID = process.env.REACT_APP_GOOGLE_SHEETS_ID;
  const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
  const RANGE = "France";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${RANGE}?key=${API_KEY}`
        );
        const rows = response.data.values;
        console.log(rows);
        setData(rows);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (data.length > 1) {
      const headers = data[0];
      const rows = data.slice(1);
      const formatted = rows.map((row) => {
        const obj = {};
        headers.forEach((header, index) => {
          obj[header] = row[index] || "";
        });
        return obj;
      });

      if (formatted != null) {
        var filteredData = formatted.filter(
          (item) => item.ville === nameCity.toUpperCase()
        );

        filteredData.sort((a, b) => {
          if (a.utilise_clotere === "oui" && b.utilise_clotere === "non") {
            return -1;
          }
          if (a.utilise_clotere === "non" && b.utilise_clotere === "oui") {
            return 1;
          }
          return 0;
        });

        setNotaires(filteredData);
        setDataNotaires(filteredData);

        setLoading(false);
      }
    }
  }, [data]);

  useEffect(() => {
    if (notaires != null) {
      setItemsPage(notaires?.slice(indexOfFirstItem, indexOfLastItem));
    }
  }, [notaires]);

  useEffect(() => {
    if (notaires != null) {
      var newItems = notaires?.slice(indexOfFirstItem, indexOfLastItem);
      console.log(newItems);
      setItemsPage(newItems);
    }

    scrollToTop();
  }, [currentPage]);

  useEffect(() => {
    console.log(dataNotaires);
    if (state == true) {
      var filteredData = dataNotaires.filter(
        (item) => item.utilise_clotere === "oui"
      );

      setNotaires(filteredData);
    } else {
      var filteredData = dataNotaires.filter(
        (item) => item.ville === nameCity.toUpperCase()
      );
      setNotaires(filteredData);
    }

    setCurrentPage(1);
  }, [state]);

  if (isLoading) {
    return <Loading />;
  }
  return (
    <>
      <Helmet>
        <title>Trouver votre notaire à {nameCity}</title>
        <meta name="robots" content="index,follow" />
        <meta name="googlebot" content="index,follow" />
        <meta name='description' content='Trouvez votre Notaire grâce à Clotere, la solution qui simplifie votre passage chez le notaire.' />
        <meta property="og:site_name" content="Clotere" />
        <meta property="og:image" content="https://clotere.fr/facebook-share-webp" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="bg-gradient-to-t from-indigo-50 to-purple-50">

        <Navbar
          user={args.user}
        />
        


        {/** CONTENT */}
        <div className="container">
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">

            {/** bloc actu  */}
            <div className="mt-6 hidden sm:block">
              <ArticlesSidebar/>
            </div>
            {/** listing notaires */}
            <div className="col-span-2">
              {/** HEADER */}
        <div className="py-8">
              <nav aria-label="Breadcrumb" className="flex">
                <ol className="flex items-center space-x-4 pl-0 mb-0">
                  <li>
                    <div>
                      <Link to="/trouver-votre-notaire" className="text-xs sm:text-sm text-black font-bold no-underline hover:text-indigo-500 ">
                        Annuaire des notaires
                      </Link>
                    </div>
                  </li>
                  <li>
                    <div className="flex items-center">
                      <ChevronRightIcon aria-hidden="true" className="size-5 shrink-0 text-gray-400" />
                      <Link
                        to="/trouver/notaires/france"
                        className="ml-4 text-xs sm:text-sm text-black font-bold no-underline hover:text-indigo-5000"
                      >
                        Notaires France
                      </Link>
                    </div>
                  </li>
                  <li>
                    <div className="flex items-center">
                      <ChevronRightIcon aria-hidden="true" className="size-5 shrink-0 text-gray-400" />
                      <Link
                        to="//notaires"
                        aria-current="page"
                        className="ml-4 text-xs sm:text-sm font-base text-gray-800 hover:text-gray-700 no-underline"
                      >
                        Notaires {nameCity}
                      </Link>
                    </div>
                  </li>
                </ol>
              </nav>
              <h1 className="mt-2 !text-2xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
                Trouvez

                votre notaire

                à <span className="text-bold text-indigo-800">{nameCity}</span>
              </h1>
            </div>
              <div className="flex flex-row justify-between items-center">
                <h2 className="!text-lg font-bold text-indigo-800">

                  {notaires.length} notaires à{" "}
                  {nameCity}

                </h2>
                <FormS>
                  <FormGroup switch>
                    <Input
                      type="switch"
                      checked={state}
                      onClick={() => {
                        setState(!state);
                      }}
                    />
                    <Label check>
                      <a href="#" rel="noreferrer" id="TooltipExample">
                        Réponds rapidement
                      </a>
                    </Label>
                  </FormGroup>
                </FormS>
              </div>


              {itemsPage.length > 0 ? (
                <div className="flex gap-4 flex-col">
                  {itemsPage.map((col, i) => (
                    <>
                      <CardNotaire
                        tag="a"
                        fiche={itemsPage[i].lien_fiche}
                        key={i}
                        nom={itemsPage[i].nom}
                        adresse={itemsPage[i].adresse}
                        cp={itemsPage[i].cp}
                        ville={itemsPage[i].ville}
                        site={itemsPage[i].site}
                        use={itemsPage[i].utilise_clotere}
                        photo={itemsPage[i].photo_profil}
                      />
                    </>
                  ))}
                </div>
              ) : (
                <>
                  <h4 class="mt-5 mb-5 !text-lg text-center">
                    <span role="img">🫤</span>
                    Aucun notaire disponible pour cette recherche
                  </h4>
                </>
              )}

            <Pagination>
              <button
                onClick={() => handlePrevious()}
                disabled={currentPage === 1}
              >
                &lt; Précédent
              </button>
              <span>
                Page {currentPage} sur {totalPages}
              </span>
              <button
                className="no-underline inline-flex items-center justify-center px-5 py-[calc(theme(spacing.3)-1px)] rounded-full  border-transparent bg-gray-950 shadow-md whitespace-nowrap text-base font-medium text-white data-[disabled]:bg-[#1DF36C] data-[hover]:bg-gray-800 data-[disabled]:opacity-40"
                onClick={() => handleNext()}
                disabled={currentPage === totalPages}
              >
                Suivant &gt;
              </button>
            </Pagination>
            </div>
          </div>
        </div>
        <div className="container">
        <RechercheParVille />
          <FindePage ville={nameCity} />
        <CtaNotaire />
        </div>
        <Footer />
        
      </div>
    </>
  );
}

export default NotairesVilleParis;
